export const dealerThemes = ['light', 'medium', 'dark'] as const;
export type DEALER_THEME = (typeof dealerThemes)[number];
